import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EStatus } from '../repositories/demand/entities/get_status_about_created_message_chat_message/GetStatusAboutCreatedMessageChatMessageResponse';
import { GetReturnType } from '../types/getReturnType';

export type TFormSubmitDataState = {
  sentMessageFromCian?: boolean;
  messageId?: number;
  chat?: TChatInfo;
};

export type TChatInfo = {
  status: EStatus;
  chatId?: string | null;
};

export const formSubmitDataInitialState: TFormSubmitDataState = {};

export const formSubmitDataSlice = createSlice({
  name: 'formSubmitData',
  initialState: formSubmitDataInitialState,
  reducers: {
    setSubmitFormData(state, { payload }: PayloadAction<TFormSubmitDataState>) {
      return payload;
    },
    setChatId(state, { payload }: PayloadAction<TChatInfo>) {
      state.chat = payload;
    },
  },
});

export type TFormSubmitDataSlice = GetReturnType<typeof formSubmitDataSlice.actions>;

export const { setSubmitFormData, setChatId } = formSubmitDataSlice.actions;
